module.exports = __webpack_public_path__ + "img/upkot - Copy.e784a036.png";